import React from 'react';
import PropTypes from 'prop-types';
import get from 'lodash/get';

import { HEALTHBOARD } from '../../../constants/routes';
import Card from '../../Card';
import Avatar from '../../Avatar';

const TeamsMenu = ({ list, handleClose }) => {
  const handleClickMenItem = item => {
    if (item.isLoggedUser) {
      window.storage.removeItem('selectedTeamId');
      window.storage.removeItem('actingUserId');
    } else {
      window.storage.setItem('selectedTeamId', JSON.stringify(get(item, 'id')));
      window.storage.setItem(
        'actingUserId',
        JSON.stringify(get(item, 'actingUserId')),
      );
    }
    window.location.replace(HEALTHBOARD);
  };

  return (
    <div onMouseLeave={handleClose}>
      {list.map(item => (
        <Card
          additionalContent={{
            left: (
              <Avatar
                children={item.name}
                size={24}
                src={get(item, 'logo.thumbMin')}
              />
            ),
          }}
          className="f-14 pa2 pointer g-hoverable"
          text={{ primary: item.name }}
          key={item.id}
          handleClick={() => handleClickMenItem(item)}
        />
      ))}
    </div>
  );
};

TeamsMenu.propTypes = {
  list: PropTypes.array,
  handleClose: PropTypes.func,
};

export default TeamsMenu;



// WEBPACK FOOTER //
// ./src/components/Header/Components/TeamsMenu.jsx